"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useScripts = exports.default = void 0;
var _react = require("react");
const useScripts = _ref => {
  let {
    scriptsList
  } = _ref;
  const [isReady, setIsReady] = (0, _react.useState)(false);
  const [error, setError] = (0, _react.useState)(null);
  const MAX_LOAD_ATTEMPTS = 10;
  (0, _react.useEffect)(() => {
    let isActive = true;
    const loader = async () => {
      let promises = [];
      for (let i = 0; i < scriptsList.length; i++) {
        const scriptData = scriptsList[i];
        const promise = new Promise((resolve, reject) => {
          if (scriptData.checkIfAlreadyLoaded && typeof scriptData.checkIfAlreadyLoaded === 'function' && scriptData.checkIfAlreadyLoaded()) {
            resolve(true);
          } else {
            scriptData.loadAttemptCount = scriptData.loadAttemptCount ?? MAX_LOAD_ATTEMPTS;
            if (scriptData.loadAttemptCount <= 0) {
              reject({
                failedScriptData: scriptData
              });
            }
            var scriptElement = document.createElement('script');
            scriptElement.addEventListener('load', () => resolve(true));
            scriptElement.addEventListener('error', () => reject({
              failedScriptData: scriptData
            }));
            scriptElement.src = scriptData.src;
            scriptData.loadAttemptCount--;
            document.head.appendChild(scriptElement);
          }
        });
        if (scriptData.isWaitUntilLoaded) {
          await promise;
        }
        promises.push(promise);
      }
      Promise.all(promises).then(() => {
        if (isActive) {
          setIsReady(true);
          setError(null);
        }
      }).catch(error => {
        if (isActive) {
          setIsReady(true);
          setError(error);
        }
      });
    };
    if (!scriptsList || !scriptsList.length) {
      setIsReady(true);
      setError(null);
    } else if (scriptsList[0]?.loadAttemptCount && scriptsList[0].loadAttemptCount <= 0) {
      setIsReady(true);
      setError(error => error);
    } else {
      setIsReady(false);
      setError(null);
      loader();
    }
    return () => {
      isActive = false;
    };
  }, [scriptsList]);
  return {
    isReady,
    error
  };
};
exports.useScripts = useScripts;
var _default = exports.default = useScripts;